'use client';

import { c as _c } from "react/compiler-runtime";
import './payment-settings.scss';
import { useTranslation } from 'react-i18next';
import { IntlBlock } from '@sola/ark-core/atoms/intl/Intl.tsx';
import { Alert } from '@sola/ark-core/molecules/alert/alert.tsx';
import { usePaymentMethodsWithCommitments } from '@sola/supporter-sdk/hooks/payment-methods.ts';
import { LocalAlertsProvider } from '../../molecules/local-alerts/local-alerts-provider.tsx';
import { LocalAlerts } from '../../molecules/local-alerts/local-alerts.tsx';
import { PaymentMethodCard } from '../../molecules/payment-method-card/payment-method-card.tsx';
import { PrimerError } from '../../molecules/primer-error/primer-error.tsx';
import { SectionContent } from '../../molecules/section-content/section-content.tsx';
import { PaymentIssueAlert } from '../payment-issue-alert/payment-issue-alert.tsx';
import { PaymentMethodAddSheet } from '../payment-method-add-sheet/payment-method-add-sheet.tsx';
import { AddPaymentMethodButton, AddPaymentMethodButtonLabel } from './payment-settings-add.tsx';
const useComponentData = () => {
  const $ = _c(6);
  const {
    isLoading,
    hasError,
    paymentMethods,
    commitmentsByPaymentMethodId,
    commitments
  } = usePaymentMethodsWithCommitments();
  let t0;
  if ($[0] !== commitments || $[1] !== commitmentsByPaymentMethodId || $[2] !== hasError || $[3] !== isLoading || $[4] !== paymentMethods) {
    t0 = {
      isLoading,
      hasError,
      paymentMethods,
      commitmentsByPaymentMethodId,
      commitments
    };
    $[0] = commitments;
    $[1] = commitmentsByPaymentMethodId;
    $[2] = hasError;
    $[3] = isLoading;
    $[4] = paymentMethods;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};
export const PaymentMethodList = () => {
  const $ = _c(46);
  const {
    t
  } = useTranslation("my");
  const {
    isLoading,
    hasError,
    paymentMethods,
    commitmentsByPaymentMethodId,
    commitments
  } = useComponentData();
  const showNoPaymentMethodsAlert = !hasError && paymentMethods.length === 0 && !!commitments.length;
  if (hasError && !paymentMethods?.length) {
    let t0;
    if ($[0] !== t) {
      t0 = t("paymentMethods.queryError.title", {
        count: 0
      });
      $[0] = t;
      $[1] = t0;
    } else {
      t0 = $[1];
    }
    let t1;
    if ($[2] !== t) {
      t1 = t("paymentMethods.queryError.message");
      $[2] = t;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    let t2;
    if ($[4] !== t) {
      t2 = t("ctas.contactSupport.url");
      $[4] = t;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let t3;
    if ($[6] !== t) {
      t3 = t("ctas.contactSupport.text");
      $[6] = t;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== t2 || $[9] !== t3) {
      t4 = <a href={t2}>{t3}</a>;
      $[8] = t2;
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    let t5;
    if ($[11] !== t0 || $[12] !== t1 || $[13] !== t4) {
      t5 = <Alert variant="negative" title={t0} message={t1} action={t4} />;
      $[11] = t0;
      $[12] = t1;
      $[13] = t4;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    return t5;
  }
  let t0;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PrimerError keysToAlert={["commitments", "paymentMethods"]} />;
    $[15] = t0;
  } else {
    t0 = $[15];
  }
  let t1;
  if ($[16] !== isLoading) {
    t1 = !isLoading && <PaymentIssueAlert isSimple={true} onlyShowMissingPayment={true} />;
    $[16] = isLoading;
    $[17] = t1;
  } else {
    t1 = $[17];
  }
  let t2;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LocalAlerts className="flex flex-col gap-comfy-sm" />;
    $[18] = t2;
  } else {
    t2 = $[18];
  }
  let t3;
  if ($[19] !== isLoading || $[20] !== showNoPaymentMethodsAlert || $[21] !== t) {
    t3 = !isLoading && showNoPaymentMethodsAlert && <Alert variant="warning" title={t("payments.alerts.noPaymentMethods.title")} message={<IntlBlock i18nKey="my:payments.alerts.noPaymentMethods.message" />} dismissible={false} />;
    $[19] = isLoading;
    $[20] = showNoPaymentMethodsAlert;
    $[21] = t;
    $[22] = t3;
  } else {
    t3 = $[22];
  }
  let t4;
  if ($[23] !== t) {
    t4 = t("payments.methods.heading");
    $[23] = t;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  let t5;
  if ($[25] !== commitments || $[26] !== commitmentsByPaymentMethodId || $[27] !== isLoading || $[28] !== paymentMethods) {
    t5 = !isLoading && !!paymentMethods?.length && paymentMethods.filter(_temp).map(method_0 => <PaymentMethodCard key={`payment-method-card-${method_0.id}`} paymentMethod={method_0} paymentMethodCommitments={commitmentsByPaymentMethodId?.[method_0.id] ?? []} allCommitments={commitments} />);
    $[25] = commitments;
    $[26] = commitmentsByPaymentMethodId;
    $[27] = isLoading;
    $[28] = paymentMethods;
    $[29] = t5;
  } else {
    t5 = $[29];
  }
  let t6;
  if ($[30] !== t) {
    t6 = t("payments.addPaymentMethod");
    $[30] = t;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  let t7;
  if ($[32] !== t6) {
    t7 = <AddPaymentMethodButton><AddPaymentMethodButtonLabel>{t6}</AddPaymentMethodButtonLabel></AddPaymentMethodButton>;
    $[32] = t6;
    $[33] = t7;
  } else {
    t7 = $[33];
  }
  let t8;
  if ($[34] !== commitments || $[35] !== t7) {
    t8 = <PaymentMethodAddSheet commitments={commitments} openTrigger={t7} />;
    $[34] = commitments;
    $[35] = t7;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  let t9;
  if ($[37] !== isLoading || $[38] !== t4 || $[39] !== t5 || $[40] !== t8) {
    t9 = <SectionContent heading={t4} isLoadingContent={isLoading}>{t5}{t8}</SectionContent>;
    $[37] = isLoading;
    $[38] = t4;
    $[39] = t5;
    $[40] = t8;
    $[41] = t9;
  } else {
    t9 = $[41];
  }
  let t10;
  if ($[42] !== t1 || $[43] !== t3 || $[44] !== t9) {
    t10 = <>{t0}{t1}{t2}{t3}{t9}</>;
    $[42] = t1;
    $[43] = t3;
    $[44] = t9;
    $[45] = t10;
  } else {
    t10 = $[45];
  }
  return t10;
};
export const PaymentSettings = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="PaymentSettings max-w-md flex flex-col gap-comfy-xl"><LocalAlertsProvider><PaymentMethodList /></LocalAlertsProvider></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(method) {
  return !!method.id;
}